import { render, staticRenderFns } from "./vCarousel-item.vue?vue&type=template&id=6d62b03c&scoped=true"
import script from "./vCarousel-item.vue?vue&type=script&lang=js"
export * from "./vCarousel-item.vue?vue&type=script&lang=js"
import style0 from "./vCarousel-item.vue?vue&type=style&index=0&id=6d62b03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d62b03c",
  null
  
)

export default component.exports